var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2928 0.567522C21.27 0.830362 22.0394 1.60485 22.3006 2.58827C22.7752 4.37086 22.7752 8.0899 22.7752 8.0899C22.7752 8.0899 22.7752 11.8088 22.3006 13.5916C22.0394 14.5749 21.27 15.3493 20.2928 15.6123C18.5219 16.0899 11.4203 16.0899 11.4203 16.0899C11.4203 16.0899 4.31876 16.0899 2.54779 15.6123C1.57066 15.3493 0.801109 14.5749 0.540012 13.5915C0.0654297 11.8089 0.0654297 8.0899 0.0654297 8.0899C0.0654297 8.0899 0.0654297 4.37086 0.540012 2.58827C0.801109 1.60485 1.57066 0.830362 2.54779 0.567522C4.31876 0.0898438 11.4203 0.0898438 11.4203 0.0898438C11.4203 0.0898438 18.5219 0.0898438 20.2928 0.567522ZM15.0333 8.09159L9.09772 11.4681V4.71484L15.0333 8.09159Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.a3a1a853cda9802317245561a061ec6d.svg";
export { ForwardRef as ReactComponent };